export enum AbregelungFRELeistungsklasse {
    TYP_1 = 'TYP_1',
    TYP_2 = 'TYP_2',
    TYP_3 = 'TYP_3',
}
export class AbregelungFRELeistungsklasseItem {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): AbregelungFRELeistungsklasseItem[] {
        return [
            new AbregelungFRELeistungsklasseItem(AbregelungFRELeistungsklasse.TYP_1, 'Typ 1'),
            new AbregelungFRELeistungsklasseItem(AbregelungFRELeistungsklasse.TYP_2, 'Typ 2'),
            new AbregelungFRELeistungsklasseItem(AbregelungFRELeistungsklasse.TYP_3, 'Typ 3'),
        ];
    }

}
